<template>
  <div>
    <div class="fixed z-50 inset-0 ">
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <!--
      Background overlay, show/hide based on modal state.
    -->
        <div
          class="fixed inset-0 transition-opacity"
          aria-hidden="true"
          @click="$emit('close')"
        >
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <!--
      Modal panel, show/hide based on modal state.
    -->
        <div
          class="inline-block bg-white w-full transform transition-all align-top"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div
            class="bg-white px-4 pt-5 pb-4 mt-3 sm:mt-0 sm:ml-4 sm:items-start flex min-h-screen "
          >
            <div class="flex-grow">
              <slot name="body">
                <div class="flex flex-row-reverse">
                  <div @click="$emit('close')">
                    <svg-icon
                      icon="heroicons/solid/x"
                      class="mr-5 opacity-50 hover:opacity-100 cursor-pointer h-10 w-10"
                    />
                  </div>
                </div>

                <h3
                  class="text-lg leading-6 font-medium font-semibold text-gray-900 text-center"
                  id="modal-headline"
                >
                  Add an image
                </h3>

                <div class="flex flex-wrap ">
                  <div class="max-w-3xl mx-auto">
                    <ul
                      class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
                    >
                      <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
                        <a
                          class="text-xs font-bold uppercase px-5 py-3 block leading-normal hover:no-underline"
                          v-on:click="toggleTabs(1)"
                          v-bind:class="{
                            'text-pink-600 hover:text-pink-500 cursor-pointer':
                              openTab !== 1,
                            'text-pink-600 hover:text-pink-500 border-b-2 border-pink-500 cursor-pointer ':
                              openTab === 1,
                          }"
                        >
                          Select an image
                        </a>
                      </li>
                      <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
                        <a
                          class="text-xs font-bold uppercase px-5 py-3 block leading-normal hover:no-underline"
                          v-on:click="toggleTabs(2)"
                          v-bind:class="{
                            'text-pink-600 hover:text-pink-500 cursor-pointer':
                              openTab !== 2,
                            'text-pink-600 hover:text-pink-500 border-b-2 border-pink-500 cursor-pointer':
                              openTab === 2,
                          }"
                        >
                          Add an Image Link
                        </a>
                      </li>
                    </ul>
                    <div
                      class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 rounded"
                    >
                      <div class="px-4 py-5 flex-auto">
                        <div class="tab-content tab-space">
                          <div v-if="openTab==1">
                            <div
                              class="mt-4 flex flex-wrap -mx-2 overflow-y-scroll border-b border-solid border-gray-300 "
                              style="max-height:500px"
                            >
                              <div
                                :key="index"
                                v-for="(svg, index) in imageList"
                                class="my-2 px-2 w-1/2 overflow-hidden sm:w-1/4"
                              >
                                <div
                                  @click="
                                    image = svg;
                                    $emit('close');
                                  "
                                  class="p-2 w-full h-full border-solid border-2 border-gray-200 hover:border-blue-500 cursor-pointer rounded"
                                >

                                  <svg-inline
                                    :style="{ color: accentColor }"
                                    :image="svg"
                                  ></svg-inline>
                                  
                                </div>
                              </div>
                              
                            </div>
                          </div>
                          <div v-if="openTab==2">
                                                 
                            <div>
                              <div class="mt-1 flex rounded-md w-96">
                                
                                <input
                                  ref="externalLink"
                                  type="text"
                                  name="external_link"
                                  class="py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-r-md sm:text-sm border border-solid border-gray-300"
                                  placeholder="http://www.example.com/image.png"
                                  v-model="imageLink"
                                />

                                <button
                                  class="bg-blue-600 hover:bg-blue-500 text-white ml-4 px-4 py-2 rounded-md"
                                  @click="addLink()"
                                >
                                  Done
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </slot>
            </div>

            <hr />
            <div
              id="modal-footer"
              style="position: fixed;bottom: 5px;left: 0px;right: 0px;z-index: 20;"
            >
            Images courtesy of: <a href="https://undraw.co/illustrations" class="underline" target="_blank">Undraw.co</a>, <a href="https://2.flexiple.com/scale/home" class="underline" target="_blank"> Scale 2.0 by Flexiple</a>, <a href="https://storyset.com/" class="underline" target="_blank">Storyset.com</a> 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Option from "@/models/Option";
import SvgInline from "@/components/SvgInline";
//import SvgImage from "@/components/SvgImage";
export default {
  components: { SvgInline },
  name: "image-select-modal",
  props: ["model", "accentColor"],
  data() {
    return {
      imageList: [],
      openTab: 1,
    };
  },
  computed: {
    image: {
      get() {
        return this.model.image;
      },
      set(value) {
        this.$emit('set-image', value);
        //Option.update({ where: this.option.id, data: { image: value } });
      },
    },
    imageLink: {
      get() {
        return this.model.image_link;
      },
      set(value) {
        this.$emit('set-image-link', value);
        //Option.update({ where: this.option.id, data: { image_link: value, image: "link" } });
      },
    },
  },
  methods: {
    toggleTabs: function(tabNumber) {
      this.openTab = tabNumber;
    },
    addLink() {
      this.imageLink  = this.$refs.externalLink.value;
      this.$emit("close");
    },
  },
  created() {
    var imageList = [];
    //Automatically add all svgs in undraw dir to imageList
    const undrawImage = require.context("@/assets/svg/undraw", false, /\.svg$/);

    undrawImage.keys().forEach((fileName) => {
      const svgName = fileName.replace(/^\.\/(.*)\.\w+$/, "$1");
      imageList.push("undraw/" + svgName);
    });

    const heroicons = require.context("@/assets/svg/icons/heroicons/solid", false, /\.svg$/);

    heroicons.keys().forEach((fileName) => {
      const svgName = fileName.replace(/^\.\/(.*)\.\w+$/, "$1");
      imageList.push("icons/heroicons/solid/" + svgName);
    });

    const storysetImage = require.context("@/assets/svg/storyset", false, /\.svg$/);

    storysetImage.keys().forEach((fileName) => {
      const svgName = fileName.replace(/^\.\/(.*)\.\w+$/, "$1");
      imageList.push("storyset/" + svgName);
    });

    imageList.push("icons/heroicons/outline/home");
    imageList.push("icons/heroicons/outline/user-circle");

    this.imageList = imageList;
  },
};
</script>
